import { MMButton } from '@components'
import cn from 'classnames'
import { copyTextToClipboard, tr } from 'mmfintech-commons'
import type { ReactNode } from 'react'
import { toast } from 'react-hot-toast'

import './labelValue.scss'

type LabelValueProps = {
  label?: ReactNode
  value?: string
  dataTest?: string
  enableCopy?: boolean
  copyValue?: string
  valueClass?: string
}

const LabelValue = ({ label, value, dataTest, enableCopy, copyValue, valueClass }: LabelValueProps) => {
  const handleCopyClick = () => {
    copyTextToClipboard(copyValue || value, () => {
      toast.remove()
      toast.success(tr('FRONTEND.BANKING.COMMON.COPY_SUCCESS', 'Value copied to clipboard.'))
    })
  }

  if (value?.length) {
    return (
      <div className='label-value-wrapper'>
        <div className='label'>{label}</div>
        {enableCopy ? (
          <div className='copy-box'>
            <span data-test={dataTest}>{value}</span>
            <MMButton
              type='button'
              variant='primary'
              caption={tr('FRONTEND.BUTTONS.COPY', 'Copy')}
              onClick={handleCopyClick}
            />
          </div>
        ) : (
          <div className={cn('value', valueClass)} data-test={dataTest}>
            {value}
          </div>
        )}
      </div>
    )
  }

  return null
}

export default LabelValue
